export const initialState = {
  isReady: false,
  inProduction: true,
  issuer: null as string,
  clientId: null as string,
  isSwaggerEnabled: false,
  productCode: null as number,
  publicKeyDidomi: null as string,
  noticeIdDidomi: null as string,
  countries: [],
  title: [],
  steps: null as {
    part: string[];
    pro: string[];
  },
  languages: [],
  pendingSubscription: false,
  recaptchaActivated: false,
  recaptchaSiteKey: '',
  legalReflectionPeriodInMinutes: null as number,
  requiredFields: [],
  isWithoutOffer: false,
  documentUrl: null as string,
  redirectPaymentUrl: null as string
};

export type ConfigState = Readonly<typeof initialState>;
